<!-- MODAL modalConfirmPeriodoGestion -->
<div mdbModal #modalConfirmPeriodoGestion="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">
                    Confirmación Periodo Gestión
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="modalConfirmPeriodoGestion.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <h5>Seleccione periodo/gestión:</h5>
                <form autocomplete="off" [formGroup]="formHeader">
                  <div class="filtros-body">

                    <div class="row">
                        <div class="col" style="max-width: 200px">
                            <div class="md-form mb-0">
                                <mdb-select label="Mes/Periodo" [options]="optionsMonth" placeholder="Mes/Periodo"
                                    [filterEnabled]="true" formControlName="mesPeriodo">
                                </mdb-select>
                                <div *ngIf="
                            formHeader.get('mesPeriodo').invalid &&
                            (formHeader.get('mesPeriodo').dirty ||
                            formHeader.get('mesPeriodo').touched)
                          ">
                                    <mdb-error *ngIf="formHeader.get('mesPeriodo').hasError('required')">Ingrese periodo
                                    </mdb-error>
                                </div>
                            </div>
                        </div>

                        <div class="col" style="max-width: 200px">
                            <div class="md-form mb-0">
                                <mdb-select label="Gestión" [options]="optionsYear" placeholder="Gestión"
                                    [filterEnabled]="true" formControlName="gestion">
                                </mdb-select>
                                <div *ngIf="
                              formHeader.get('gestion').invalid &&
                              (formHeader.get('gestion').dirty ||
                              formHeader.get('gestion').touched)
                            ">
                                    <mdb-error *ngIf="formHeader.get('gestion').hasError('required')">Ingrese gestión
                                    </mdb-error>
                                </div>
                            </div>
                        </div>

                        <div class="col" style="max-width: 300px;">
                            <div class="md-form">
                                <mdb-select [options]="optionsBodega" [multiple]="false" [filterEnabled]="true"
                                    [highlightFirst]="false" placeholder="Seleccionar bodega" formControlName="bodega"
                                    required>
                                </mdb-select>
                                <label>Bodega</label>
                                <div *ngIf="
                                        formHeader.get('bodega').invalid &&
                                        (formHeader.get('bodega').dirty ||
                                        formHeader.get('bodega').touched)
                                      ">
                                    <mdb-error *ngIf="formHeader.get('bodega').hasError('required')">
                                        Ingrese bodega
                                    </mdb-error>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="row">
                      <div class="col">
                        <div class="md-form" style="margin-bottom: 0">
                          <mdb-checkbox [checked]="true" formControlName="GMovStock"
                           >
                            <span style="font-size: 1rem">Mueve stock</span>
                          </mdb-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
                    (click)="modalConfirmPeriodoGestion.hide()" mdbWavesEffect>
                    Cerrar
                </button>
                <button type="button" class="btn btn-success waves-light" data-dismiss="modal" (click)="accept()"
                    mdbWavesEffect>
                    Confirmar
                </button>
            </div>
        </div>
    </div>
</div>
